<template>
    <div id="main">
        <div class="page">
            <div class="mapa-cliente-vendedor">
                <!-- Título -->
                <h1 class="title">{{ $t('mapa-clientes-vendedor') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a>{{ $t('vendas') }}</a>
                        </li>
                        <li>
                            <a>{{ $t('geoanalise') }}</a>
                        </li>
                        <li>
                            <a href="#" aria-current="page">{{ $t('mapa-clientes-vendedor') }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="mapa-wrapper" :class="{ disabled: isLoading }">
                    <div class="columns">
                        <!-- Mapa -->
                        <div class="column is-full">
                            <gmap-map
                                ref="mapRef"
                                :center="center"
                                :zoom="zoomLevel"
                                :options="mapOptions"
                                @zoom_changed="checkIfOpenedWindowInCluster"
                            >
                                <!-- Balão de Informações -->
                                <gmap-info-window
                                    ref="infoWindow"
                                    :position="infoWindow.position"
                                    :opened="infoWindow.open"
                                    @closeclick="closeInfo"
                                >
                                    <div class="info-window">
                                        <p class="info-window-nome">
                                            {{ infoWindow.item.rsocial }}
                                        </p>
                                        <div class="info-details">
                                            <span v-if="!validaEndereco(infoWindow)">
                                                {{ $t('endereco-do-promotor') }}
                                                {{
                                                    infoWindow.item.endereco &&
                                                    infoWindow.item.endereco != 'null'
                                                        ? infoWindow.item.endereco
                                                        : ''
                                                }}
                                                {{
                                                    (infoWindow.item.endereco &&
                                                        infoWindow.item.endereco != 'null' &&
                                                        infoWindow.item.numero &&
                                                        infoWindow.item.numero != 'null') ||
                                                    (infoWindow.item.endereco &&
                                                        infoWindow.item.endereco != 'null' &&
                                                        infoWindow.item.bairro &&
                                                        infoWindow.item.bairro != 'null')
                                                        ? ','
                                                        : ''
                                                }}
                                                {{
                                                    infoWindow.item.numero &&
                                                    infoWindow.item.numero != 'null'
                                                        ? infoWindow.item.numero
                                                        : ''
                                                }}
                                                {{
                                                    infoWindow.item.bairro &&
                                                    infoWindow.item.bairro != 'null' &&
                                                    infoWindow.item.numero &&
                                                    infoWindow.item.numero != 'null'
                                                        ? ','
                                                        : ''
                                                }}
                                                {{
                                                    infoWindow.item.bairro &&
                                                    infoWindow.item.bairro != 'null'
                                                        ? infoWindow.item.bairro
                                                        : ''
                                                }}
                                                <br />
                                            </span>
                                            <div v-if="infoWindow.item.cidade">
                                                {{ $t('cidade-do-promotor') }}
                                                {{ infoWindow.item.cidade.descricao
                                                }}{{
                                                    infoWindow.item.estado
                                                        ? ' - ' + infoWindow.item.estado.descricao
                                                        : ''
                                                }}
                                            </div>

                                            <div v-if="infoWindow.item.regiao">
                                                {{ $t('regiao') }}:
                                                {{ infoWindow.item.regiao.descricao }}
                                            </div>

                                            <div v-if="infoWindow.item.atividade">
                                                {{ $t('atividade') }}:
                                                {{ infoWindow.item.atividade.descricao }}
                                            </div>

                                            <div v-if="infoWindow.item.vendedores">
                                                {{ $t('vendedores') }}:

                                                {{
                                                    sellerTruncate
                                                        ? infoWindow.item.vendedores[0]
                                                        : infoWindow.item.vendedores
                                                              .toString()
                                                              .replaceAll(',', ', ')
                                                }}

                                                <button
                                                    v-if="infoWindow.item.vendedores.length > 1"
                                                    class="ml-1 seller-btn"
                                                    @click="sellerTruncate = !sellerTruncate"
                                                >
                                                    {{
                                                        sellerTruncate
                                                            ? `+ ${
                                                                  infoWindow.item.vendedores
                                                                      .length - 1
                                                              }`
                                                            : '-'
                                                    }}
                                                </button>
                                            </div>

                                            <b-collapse :open.sync="infoWindow.detailsOpen">
                                                <button
                                                    class="btn-expand"
                                                    slot="trigger"
                                                    @click="toggleDetails"
                                                >
                                                    {{ $t('detalhes') }}
                                                    <b-icon
                                                        :icon="
                                                            infoWindow.detailsOpen
                                                                ? 'menu-up'
                                                                : 'menu-down'
                                                        "
                                                        size="is-small"
                                                    >
                                                    </b-icon>
                                                </button>

                                                <div v-if="infoWindow.item.datafundacao">
                                                    <span>{{ $t('fundacao') }}:</span>
                                                    <span class="item-detail">{{
                                                        getDate(infoWindow.item.datafundacao)
                                                    }}</span>
                                                </div>

                                                <span>{{ $t('titulos') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.titulosvencidos +
                                                    ' ' +
                                                    $t('vencidos')
                                                }}</span>
                                                <br />
                                                <span class="item-detail">{{
                                                    infoWindow.item.titulosavencer +
                                                    ' ' +
                                                    $t('a-vencer')
                                                }}</span>
                                                <br />
                                                <span>{{ $t('qtd-nao-vendas') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.qtdnaovenda
                                                }}</span>
                                                <br />

                                                <span>{{ $t('qtd-tomada-preco') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.qtdtomadadepreco
                                                }}</span>
                                                <br />

                                                <span>{{ $t('qtd-contatos') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.qtdcontatos
                                                }}</span>
                                                <br />

                                                <span>{{ $t('latitude') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.latitude
                                                }}</span>
                                                <br />

                                                <span>{{ $t('longitude') }}:</span>
                                                <span class="item-detail">{{
                                                    infoWindow.item.longitude
                                                }}</span>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </gmap-info-window>
                            </gmap-map>
                        </div>
                    </div>

                    <!-- Botão de retrair -->
                    <div
                        ref="retractBtn"
                        class="retract-button"
                        :class="{ 'hide-control-right-btn': !showVendedores }"
                        v-show="!isLoading && !$root.gmapsFailure"
                    >
                        <div class="btn-wrapper" @click="showVendedores = !showVendedores">
                            <b-icon :icon="showVendedores ? 'chevron-right' : 'chevron-left'" />
                        </div>
                    </div>
                    <!-- Lista de Vendedores - Dentro do Mapa -->
                    <div
                        ref="listaVendedores"
                        class="control-right"
                        :class="{ 'hide-control-right': !showVendedores }"
                        v-show="!isLoading && !$root.gmapsFailure"
                    >
                        <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
                        <alert-container :messages="msgs" />
                        <div class="control-container">
                            <!-- Abas -->
                            <div class="control-tabs">
                                <!-- Exibe icone caso possua clientes com cordenadas erradas e aprenseta tooltip. Se clicar no tooltip abre modal com lista de clientes -->
                                <button
                                    class="b-warning-client"
                                    @click="onClickWarningclient()"
                                    v-tippy
                                    :title="$t('msg-warning-customers-with-wrong-coordinates')"
                                >
                                    <svg
                                        svg
                                        class="svg-icons warning-client"
                                        v-show="hasClientsInvalidCoordinates"
                                    >
                                        <use
                                            :xlink:href="
                                                require('@/assets/img/icons/alert.svg') + '#layer'
                                            "
                                        ></use>
                                    </svg>
                                </button>
                                <ul class="nav nav-tabs">
                                    <li
                                        v-for="(a, i) in abas"
                                        :class="{ active: abaAtual == i }"
                                        :key="i"
                                        @click="abaAtual = i"
                                    >
                                        <a data-toggle="tab" href="#">{{ $t(a) }}</a>
                                    </li>
                                </ul>
                            </div>
                            <!-- Aba Vendedores -->
                            <div class="lista-vendedores" v-show="abaAtual == 0">
                                <!-- Pesquisa e botões -->
                                <search-bar
                                    class="search-input"
                                    :onSearch="debouncedOnSearch"
                                    :placeholder="$t('mapa-clientes-vendedor-busca-placeholder')"
                                    disableTitle
                                />
                                <div class="btn-row">
                                    <button
                                        class="primary-btn marcar"
                                        @click="setVisibility(false)"
                                        :disabled="isSearching"
                                    >
                                        {{ $t('desmarcar-todos') }}
                                    </button>
                                    <button
                                        class="primary-btn marcar"
                                        @click="setVisibility(true)"
                                        :disabled="isSearching"
                                    >
                                        {{ $t('marcar-todos') }}
                                    </button>
                                </div>

                                <!-- Lista de Vendedores -->
                                <div class="table-controls">
                                    <div
                                        class="vendedor-header"
                                        :class="{
                                            ordered: isOrderedBy == 'nome',
                                            disabled: isSearching,
                                        }"
                                        @click="orderBy('nome', sortDirection, true)"
                                    >
                                        {{ $t('vendedor') }}
                                        <svg
                                            class="svg-icons"
                                            v-show="isOrderedBy == 'nome' && sortDirection == false"
                                        >
                                            <use
                                                :xlink:href="
                                                    require('@/assets/img/icons/arrow-down.svg') +
                                                    '#layer'
                                                "
                                            ></use>
                                        </svg>
                                        <svg
                                            class="svg-icons"
                                            v-show="isOrderedBy == 'nome' && sortDirection == true"
                                        >
                                            <use
                                                :xlink:href="
                                                    require('@/assets/img/icons/arrow-up.svg') +
                                                    '#layer'
                                                "
                                            ></use>
                                        </svg>
                                    </div>
                                    <div
                                        class="cliente-header"
                                        :class="{
                                            ordered: isOrderedBy == 'qtd',
                                            disabled: isSearching,
                                        }"
                                        @click="orderBy('qtd', sortDirection, true)"
                                    >
                                        <svg
                                            class="svg-icons"
                                            v-show="isOrderedBy == 'qtd' && sortDirection == false"
                                        >
                                            <use
                                                :xlink:href="
                                                    require('@/assets/img/icons/arrow-down.svg') +
                                                    '#layer'
                                                "
                                            ></use>
                                        </svg>
                                        <svg
                                            class="svg-icons"
                                            v-show="isOrderedBy == 'qtd' && sortDirection == true"
                                        >
                                            <use
                                                :xlink:href="
                                                    require('@/assets/img/icons/arrow-up.svg') +
                                                    '#layer'
                                                "
                                            ></use>
                                        </svg>
                                        {{ $t('clientes') }}
                                    </div>
                                </div>
                                <div class="columns lista-wrapper is-mobile">
                                    <div class="column is-paddingless lista-container">
                                        <div
                                            class="columns is-multiline is-mobile"
                                            :class="isSearching ? 'disabled' : ''"
                                        >
                                            <div
                                                class="column is-full is-flex lista-item"
                                                v-for="v in sellers"
                                                :key="v.id"
                                                @click="toggleState(v)"
                                            >
                                                <div class="vendedor">
                                                    <b-icon
                                                        icon="circle"
                                                        size="is-small"
                                                        :style="`color: ${
                                                            visibilityMap[v.id].visible
                                                                ? v.cor
                                                                : '#999'
                                                        }; width: 10px;`"
                                                    />
                                                    <span
                                                        class="text"
                                                        :class="
                                                            !visibilityMap[v.id].visible
                                                                ? 'inativo'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            v.nome == null
                                                                ? $t('sem-vendedor').toUpperCase()
                                                                : v.nome.toUpperCase()
                                                        }}
                                                    </span>
                                                </div>
                                                <div class="estatistica">
                                                    <span
                                                        :class="
                                                            !visibilityMap[v.id].visible
                                                                ? 'inativo'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            visibilityMap[v.id].qtd
                                                                ? visibilityMap[v.id].qtd
                                                                : 0
                                                        }}{{
                                                            totalAllClientes > 0
                                                                ? ' - ' +
                                                                  format(
                                                                      visibilityMap[v.id].qtd /
                                                                          totalAllClientes
                                                                  )
                                                                : ''
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Totalizador -->
                                <div class="table-count">
                                    <div>{{ $t('sellers') }}: {{ total.vendedores }}</div>
                                    <div>{{ $t('clientes') }}: {{ total.clientes }}</div>
                                </div>
                                <center>
                                    {{ $t('listagem-clientes-vendedor') }}
                                </center>
                            </div>

                            <!-- Aba Filtros -->
                            <div class="filtros-main" v-show="abaAtual == 1">
                                <!-- Atividade -->
                                <label v-text="$t('atividade')" />
                                <v-select
                                    class="smaller"
                                    @search="loadAtividades"
                                    :options="atividades"
                                    :disabled="isSearching"
                                    v-model="atividade"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </v-select>

                                <!-- Região -->
                                <label v-text="$t('regiao')" />
                                <v-select
                                    class="smaller"
                                    @search="loadRegioes"
                                    :options="regioes"
                                    :disabled="isSearching"
                                    v-model="regiao"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </v-select>

                                <!-- Situação -->
                                <vss-select
                                    title="situacao"
                                    class="smaller"
                                    @search="loadSituacoes"
                                    :options="situacoes"
                                    :disabled="isSearching"
                                    :closeOnSelect="false"
                                    v-model="situacao"
                                    :tooltipMultilined="true"
                                    tooltipPosition="is-right"
                                    tooltipLabel="situacao-incluidos-inativos"
                                    tooltipSize="is-small"
                                    multiple
                                    clearable
                                    searchable
                                />

                                <div class="filter-footer-right is-flex is-flex-hright">
                                    <b-button
                                        type="is-silver"
                                        icon-right="backspace"
                                        @click="removeFilter"
                                        class="mr-2"
                                        :disabled="isLoading"
                                    >
                                        {{ $t('limpar') }}
                                    </b-button>
                                    <b-button
                                        type="is-primary"
                                        icon-right="filter"
                                        @click="applyFilter"
                                        :disabled="isLoading"
                                    >
                                        {{ $t('filtrar') }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Modal com clientes que estão faltando cordenada corretas - Feito neste local para pegar a tela toda.-->
        <b-modal
            class="modal-warning-client"
            :active.sync="isShowWarningclients"
            style="z-index: 1000"
            @close="onClickWarningclient()"
        >
            <div class="modal-warning-list-client">
                <h1 class="title">{{ $t('mapa-clientes-vendedor-aviso-coordenadas-erradas') }}</h1>

                <b-table :data="clientsInvalidCoordinates" responsive class="table">
                    <!-- ID -->
                    <b-table-column
                        :label="$t('idclienteerp')"
                        class="td-center"
                        width="120"
                        v-slot="props"
                    >
                        {{ props.row['idclienteerp'] }}
                    </b-table-column>
                    <!-- NOME Vendedor-->
                    <b-table-column :label="$t('cliente')" class="td-center" v-slot="props">
                        <pre>{{ props.row['nome'] }}</pre>
                    </b-table-column>
                    <!-- Ação -->
                    <b-table-column
                        :label="$t('editar-cliente')"
                        class="alnright"
                        width="140"
                        v-slot="props"
                    >
                        <router-link
                            :to="{
                                name: 'ven-cliente-dados-cadastrais-edit',
                                params: { id: props.row['idcliente'] },
                            }"
                        >
                            {{ $t('editar') }}
                            <b-icon icon="map-marker" class="location-icon" />
                        </router-link>
                    </b-table-column>
                </b-table>
            </div>
        </b-modal>
    </div>
</template>

<script>
import GeoanaliseService from '@/services/GeoanaliseService';
import FiltroRelatorioService from '@/services/FiltroRelatorioService';
import SituacaoService from '@/services/SituacaoService';
import { gmapApi } from 'vue2-google-maps';
import paleta from '@/functions/color/paleta.js';
import Message from '@/models/Message';
import MarkerClusterer from 'marker-clusterer-plus';

export default {
    data() {
        return {
            cluster: null,
            center: { lat: -15, lng: -50 },
            zoomLevel: 4,
            vendedores: [],
            markers: [],
            filteredMarkers: [],
            service: null,
            abas: ['vendedores', 'filtros'],
            abaAtual: 0,
            isSearching: false,
            /**
             * Este é um objeto que cada uma das propriedades é o ID de um vendedor
             * Possui atributos para dizer se ele é visível no mapa ou não, e também
             * definir a visibilidade dos seus clientes.
             */
            visibilityMap: {},
            /**
             * Dados do popup de informações que aparece no mapa
             */
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                detailsOpen: false,
                item: {},
            },
            /**
             * Opções do cluster. Referência:
             * https://googlemaps.github.io/v3-utility-library/interfaces/_google_markerclustererplus.markerclustereroptions.html
             */
            clusterOptions: {
                maxZoom: 12,
                zoomOnClick: true,
                minimumClusterSize: 2,
                styles: [
                    {
                        textColor: 'white',
                        url: '', // Traz a imagem no mounted pra garantir o tema carregado
                        fontFamily: 'Montserrat,sans-serif',
                        fontWeight: 'normal',
                        height: 45,
                        width: 45,
                    },
                ],
            },
            /**
             * Opções do mapa: Referência
             * https://developers.google.com/maps/documentation/javascript/controls#ControlOptions
             */
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    position: 7, //google.maps.ControlPosition.RIGHT_TOP
                },
            },
            isLoading: true,
            colors: [],
            /* SVG do pin */
            svgpath:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
            msgs: [],
            showVendedores: true,
            isOrderedBy: '',
            sortDirection: null, // false == Ascendente, true == Descendente.
            filtro: {},
            atividades: [],
            atividade: null,
            situacoes: [],
            situacao: null,
            regioes: [],
            regiao: null,
            searchVal: '',
            totalAllClientes: 0,

            //Esta var faz EXIBIR/NÃO EXIBIT o aviso que possui clientes com coordenadas erradas.
            hasClientsInvalidCoordinates: false,
            //Exbie modal com lista de clientes com coordenadas errado.
            isShowWarningclients: false,
            clientsInvalidCoordinates: [],
            permissao: {},
            // @85699 - checa se o us
            sellerTruncate: true,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'relatorio-geoanalise',
            'mapa-clientes-vendedor'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'mapa-clientes-vendedor' },
            });

        this.colors = paleta.colorList;
        this.service = new GeoanaliseService(this.$http, this.$router);
        this.filterService = new FiltroRelatorioService(this.$http, this.$router);
        this.situacaoService = new SituacaoService(this.$http, this.$router);

        this.debouncedOnSearch = this.debounce(this.searchClientes, 500);
        this.loadAtividades('');
        this.loadRegioes('');
        this.loadSituacoes();
    },
    mounted() {
        let ven = [];
        let mkr = [];

        /**
         * Aqui vai esperar o mapa carregar para então criar o cluster
         * e carregar os dados
         */
        this.$refs.mapRef.$mapPromise
            .then((map) => {
                /**
                 * Criação do cluster. Os dados serão inseridos após o carregamento.
                 */
                this.clusterOptions.styles[0].url = this.getMapClusterSvg();
                this.cluster = new MarkerClusterer(
                    this.$refs.mapRef.$mapObject,
                    [],
                    this.clusterOptions
                );

                /* Coloca as divs do painel dentro do mapa. Para isso precisa do ref neles. */
                map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
                map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
                    this.$refs.listaVendedores
                );

                this.service
                    .findClientsbySellers({}, '')
                    .then((res) => {
                        //Chama método para validar as coordenadas
                        res = this.validateCoordinateClientsBySeller(res);
                        res.forEach((v, i) => {
                            /* Coloca uma cor aleatória a cada um dos vendedores */
                            let thisv = {
                                id: v.clients[0].idvendedor,
                                nome: v.descricao,
                                cor: this.colors[(4 + i * 2) % this.colors.length],
                                clients: v.clients,
                            };

                            ven.push(thisv);

                            this.visibilityMap[thisv.id] = {};
                            this.visibilityMap[thisv.id].inSearch = true;
                            this.visibilityMap[thisv.id].visible = false;
                            this.visibilityMap[thisv.id].qtd = v.clients.length;
                            this.visibilityMap[thisv.id].name = v.descricao;
                            this.visibilityMap[thisv.id].idVendedor = v.id;

                            v.clients.forEach((c) => {
                                c.hasInfo = false;
                                c.info = [];

                                // Separa por vendedor e cliente pois um cliente pode pertencer a mais de um vendedor
                                this.visibilityMap[c.idvendedor][c.idcliente] = true;

                                let self = this;
                                let marker = new google.maps.Marker({
                                    clienteId: c.idcliente,
                                    vendedorId: c.idvendedor,
                                    position: {
                                        lat: parseFloat(c.latitude),
                                        lng: parseFloat(c.longitude),
                                    },
                                    icon: require(`@/assets/img/icons/marker-${thisv.cor.replace(
                                        '#',
                                        ''
                                    )}.png`),
                                    optimized: true,
                                });

                                marker.addListener('click', function () {
                                    self.openInfo(marker);
                                });

                                mkr.push(marker);
                                this.totalAllClientes++;
                            });
                        });

                        this.vendedores = ven.sort((a, b) => {
                            return a.nome.localeCompare(b.nome);
                        });

                        this.markers = mkr;
                        this.filteredMarkers = mkr;

                        // Centralizando o mapa em volta dos marcadores
                        let bounds = new google.maps.LatLngBounds();

                        this.markers.forEach((m) => {
                            bounds.extend(m.position);
                        });

                        map.fitBounds(bounds);

                        this.isLoading = false;
                    })
                    .catch((error) => {
                        this.msgs.push(new Message('error', 'msg-erro-relatorio', true));

                        console.error(error);
                    });

                setTimeout(() => {
                    this.gmnoprintZindex();
                }, 1000);
            })
            .catch((error) => {
                this.msgs.push(new Message('error', 'msg-erro-relatorio', true));

                console.error(error);
            });
    },
    methods: {
        onClickWarningclient() {
            !this.isShowWarningclients
                ? (this.isShowWarningclients = true)
                : (this.isShowWarningclients = false);
        },
        validateCoordinateClientsBySeller(markers) {
            let clients_temp = [];
            markers.forEach((marker, i) => {
                marker.clients.forEach((client, index) => {
                    let lat = Number(client.latitude);
                    let lgn = Number(client.longitude);
                    let validLatitude = lat >= -90 && lat <= 90 ? true : false;
                    let validLongitude = lgn >= -180 && lgn <= 180 ? true : false;
                    if (!validLatitude || !validLongitude) {
                        markers[i].clients.splice(index, 1);

                        this.hasClientsInvalidCoordinates = true;
                        if (
                            clients_temp.find((c) => c.idcliente == client.idcliente) ? false : true
                        ) {
                            clients_temp.push(client);
                        }
                    }
                });
                this.clientsInvalidCoordinates = clients_temp;
            });

            if (this.hasClientsInvalidCoordinates == true) {
                this.showMessage('alert', 'msg-warning-customers-with-wrong-coordinates', 10);
            }

            return markers.filter(({ clients }) => clients.length);
        },

        toggleState(v) {
            this.visibilityMap[v.id].visible = !this.visibilityMap[v.id].visible;

            v.clients.forEach((c) => {
                this.visibilityMap[c.idvendedor][c.idcliente] = this.visibilityMap[v.id].visible;
            });

            if (
                v.nome == this.infoWindow.item.vendedor &&
                !this.visibilityMap[v.id].visible &&
                this.infoWindow.open
            ) {
                this.infoWindow.open = false;
            }

            this.updateMarkers();
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        setVisibility(v) {
            this.sellers.forEach((s) => {
                this.visibilityMap[s.id].visible = v;
                s.clients.forEach((c) => {
                    this.visibilityMap[c.idvendedor][c.idcliente] = v;
                });
            });

            if (this.sellers.length == 0) {
                this.showMessage('alert', 'msg-warning-loc-noresults');
            }

            if (!v) {
                this.infoWindow.open = false;
            }

            this.updateMarkers();
        },
        openInfo(m) {
            this.infoWindow.open = false;
            let vendedor = this.vendedores.find((v) => {
                return v.id == m.vendedorId;
            });

            let cliente = {};

            if (vendedor != undefined) {
                cliente = vendedor.clients.find((c) => {
                    return m.clienteId == c.idcliente;
                });

                if (cliente != undefined) {
                    if (cliente.hasInfo) {
                        this.infoWindow.position = m.position;
                        this.$nextTick(() => {
                            this.infoWindow.open = true;
                        });
                        this.infoWindow.item = cliente.info;
                    } else {
                        this.findClientById(m, cliente);
                    }
                } else {
                    console.warn(
                        `Não foi encontrado o cliente ID ${m.clienteId} no vendedor ${vendedor.nome}.`
                    );
                }
            } else {
                this.findClientById(m, cliente);
            }
        },
        findClientById(m, cliente) {
            this.service
                .findClientById(cliente.idcliente)
                .then((r) => {
                    if (r.clients && r.clients.length > 0) {
                        cliente.hasInfo = true;
                        cliente.info = r.clients[0];

                        this.infoWindow.position = m.position;
                        this.infoWindow.open = true;
                        this.infoWindow.item = cliente.info;
                        this.infoWindow.item.vendedores = this.infoWindow.item.vendedores.split(
                            ','
                        );

                        // Se um usuário só foi selecionado ele é exibido como primeiro na info
                        let sellectedSeller = this.sellers.filter(
                            (s) =>
                                s.nome == this.visibilityMap[s.id].name &&
                                this.visibilityMap[s.id].visible
                        );

                        if (sellectedSeller.length == 1) {
                            this.infoWindow.item.vendedores = this.infoWindow.item.vendedores.filter(
                                (vend) => vend != sellectedSeller[0].nome
                            );
                            this.infoWindow.item.vendedores.unshift(sellectedSeller[0].nome);
                        }
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar informações do cliente ${cliente.idcliente} para o balão do pin.`
                    );
                });
        },
        closeInfo() {
            this.infoWindow.open = false;
            this.sellerTruncate = true;
        },
        toggleDetails() {
            // Recentraliza a info window ao abrir os detalhes
            this.$refs.mapRef.$mapPromise.then((map) => {
                this.$refs.infoWindow.$infoWindowPromise.then((iw) => {
                    iw.open(map);
                });
            });
        },
        format(number) {
            return number.toLocaleString(undefined, {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        getDate(d) {
            if (d != '' && d != undefined) {
                let date = new Date(d);
                return date.toLocaleDateString();
            } else {
                return '';
            }
        },
        updateMarkers() {
            this.filteredMarkers = this.markers.filter((m) => {
                return (
                    this.visibilityMap[m.vendedorId][m.clienteId] &&
                    this.visibilityMap[m.vendedorId].inSearch &&
                    this.visibilityMap[m.vendedorId].visible
                );
            });
            this.cluster.clearMarkers();
            this.cluster.addMarkers(this.filteredMarkers);
            this.$forceUpdate();
        },
        orderBy(field, direction, changeSortDirection) {
            this.isOrderedBy = field;
            if (direction == null) {
                this.sortDirection = false;
            } else if (changeSortDirection) {
                this.sortDirection = !direction;
            }

            if (field == 'nome') {
                this.vendedores.sort(this.compareNome);
            } else if (field == 'qtd') {
                this.vendedores.sort(this.compareQTD);
            }
        },
        compareNome(a, b) {
            if (!this.sortDirection) {
                // Ascendente
                if (a.nome < b.nome) {
                    return -1;
                }
                if (a.nome > b.nome) {
                    return 1;
                }
            } else {
                // Descendente
                if (a.nome < b.nome) {
                    return 1;
                }
                if (a.nome > b.nome) {
                    return -1;
                }
            }
            return 0;
        },
        compareQTD(a, b) {
            if (this.sortDirection) {
                // Ascendente
                if (a.clients.length < b.clients.length) {
                    return -1;
                }
                if (a.clients.length > b.clients.length) {
                    return 1;
                }
            } else {
                // Descendente
                if (a.clients.length < b.clients.length) {
                    return 1;
                }
                if (a.clients.length > b.clients.length) {
                    return -1;
                }
            }
            return 0;
        },
        checkIfOpenedWindowInCluster() {
            if (this.infoWindow.open) {
                let cliente = this.infoWindow.item.idcliente;
                let delay = this.markers.length * 0.2;

                setTimeout(
                    () => {
                        this.cluster.getClusters().forEach((c) => {
                            if (c.markers_.length > this.clusterOptions.minimumClusterSize - 1) {
                                c.markers_.some((m) => {
                                    if (m.clienteId == cliente) {
                                        this.infoWindow.open = false;
                                    }
                                    return m.clienteId == cliente;
                                });
                            }
                        });
                    },
                    delay > 500 ? delay : 500
                );
            }
        },
        checkIfOpenedWindowInResults() {
            if (this.infoWindow.open) {
                let cliente = this.infoWindow.item.idcliente;
                let open = false;

                this.sellers.forEach((v) => {
                    v.clients.forEach((c) => {
                        if (c.idcliente == cliente) {
                            open = true;
                        }
                    });
                });

                this.infoWindow.open = open;
            }
        },
        loadAtividades(val) {
            this.filterService
                .findAllAtividade(0, 50, val)
                .then(this.mapItems)
                .then((r) => {
                    this.atividades = r;
                });
        },
        loadRegioes(val) {
            this.filterService
                .findAllRegiao(0, 50, val)
                .then(this.mapItems)
                .then((r) => {
                    this.regioes = r;
                });
        },
        loadSituacoes() {
            this.situacaoService
                .findAllVendas('descricao', 'desc', 0, 50, 1)
                .then(this.mapItemsSituacao)
                .then((r) => {
                    this.situacoes = r;
                });
        },
        mapItems(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.id,
                    label: i.descricao,
                };
            });

            return list;
        },
        mapItemsSituacao(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.idsituacao,
                    label: i.descricao,
                };
            });

            return list;
        },
        removeFilter() {
            this.situacao = null;
            this.regiao = null;
            this.atividade = null;

            this.applyFilter();
        },
        applyFilter() {
            this.isSearching = true;

            this.filtro = {
                atividade: this.atividade != null ? { idatividade: this.atividade.id } : null,
                situacao:
                    this.situacao != null
                        ? this.situacao.map((situacao) => ({ idsituacao: situacao.id }))
                        : null,
                regiao: this.regiao != null ? { idregiao: this.regiao.id } : null,
            };

            const vueVm = this;
            
            this.service.findClientsbySellers(this.filtro, '')
                .then(res => {
                    let ven = [];
                    let mkr = [];
                    res.forEach((v, i) => {
                        let thisv = {
                            id: v.clients[0].idvendedor,
                            nome: v.descricao,
                            cor: vueVm.getColorFromVendedorId(v.clients[0].idvendedor),
                            clients: v.clients,
                        };

                    ven.push(thisv);

                    v.clients.forEach((c) => {
                        c.hasInfo = false;
                        c.info = [];

                        let self = this;
                        let marker = new google.maps.Marker({
                            clienteId: c.idcliente,
                            vendedorId: c.idvendedor,
                            position: {
                                lat: parseFloat(c.latitude),
                                lng: parseFloat(c.longitude),
                            },
                            icon: require(`@/assets/img/icons/marker-${thisv.cor.replace(
                                '#',
                                ''
                            )}.png`),
                            optimized: true,
                        });

                        marker.addListener('click', function () {
                            self.openInfo(marker);
                        });
                        mkr.push(marker);
                    });
                });

                this.vendedores = ven.sort((a, b) => {
                    return a.nome.localeCompare(b.nome);
                });

                this.markers = mkr;
                this.updateMarkers();
                this.searchClientes(this.searchVal);
            });
        },
        searchClientes(val) {
            this.isSearching = true;
            this.searchVal = val;

            this.service
                .findClientsbySellers(this.filtro, val)
                .then(this.mapVendedores)
                .then((res) => {
                    // Abordagem de modificar o array atual (this.vendedores) ao invés de substituir
                    // pelo que veio da request (res), para poder guardar se ele estava marcado ou não antes da pesquisa

                    let newv = res.map((v) => v.clients[0].idvendedor); // Vendedores novos, da request
                    let oldv = this.vendedores.map((v) => v.id); // Vendedores atuais, pré-pesquisa

                    let remover = oldv.filter((x) => !newv.includes(x)); // Filtra vendedores que não vieram na request, para remover da lista
                    let incluir = newv.filter((x) => !oldv.includes(x)); // Filtra vendedores que não estavam antes, para adicionar da lista
                    let modificar = oldv.filter((x) => newv.includes(x)); // Filtra os que estão em ambos os grupos, pra filtrar os clientes dentro deles

                    remover.forEach((item) => {
                        let idx = this.vendedores.findIndex((cd) => cd.id == item);

                        if (idx > -1) {
                            this.visibilityMap[this.vendedores[idx].id].inSearch = false;

                            this.vendedores.splice(idx, 1);
                        }
                    });

                    incluir.forEach((item) => {
                        let idx = res.findIndex((cd) => cd.id == item);

                        if (idx > -1) {
                            this.vendedores.push(res[idx]);

                            // Retirar visibilidade de todos, para incluir os que não estão na pesquisa
                            for (var c in this.visibilityMap[res[idx].id]) {
                                if (c != 'inSearch' && c != 'visible' && c != 'qtd') {
                                    this.visibilityMap[res[idx].id][c] = false;
                                }
                            }

                            res[idx].clients.forEach((cl) => {
                                this.visibilityMap[res[idx].id][cl.idcliente] = true;
                            });

                            this.visibilityMap[res[idx].id].inSearch = true;
                        }
                    });

                    modificar.forEach((item) => {
                        let idxa = this.vendedores.findIndex((cd) => cd.id == item);
                        let idxn = res.findIndex((cd) => cd.id == item);

                        if (idxn > -1 && idxa > -1) {
                            let vena = this.vendedores[idxa];

                            // vena contém os clientes que não estão presentes na pesquisa, então eles precisam ser retirados
                            vena.clients.forEach((c) => {
                                this.visibilityMap[vena.id][c.idcliente] = false;
                            });

                            // res contém os clientes que vieram da request, então recupera sua visibilidade do vendedor
                            res[idxn].clients.forEach((c) => {
                                this.visibilityMap[vena.id][c.idcliente] = this.visibilityMap[
                                    vena.id
                                ].visible;
                            });

                            vena.clients = res[idxn].clients;
                        }
                    });

                    this.orderBy(this.isOrderedBy, this.sortDirection, false);
                    this.updateMarkers();
                    this.checkIfOpenedWindowInResults();
                    this.isSearching = false;
                });
        },
        mapVendedores(body) {
            return body.map((v) => {
                return {
                    id: v.clients[0].idvendedor,
                    nome: v.descricao,
                    cor: this.getColorFromVendedorId(v.clients[0].idvendedor),
                    clients: v.clients,
                };
            });
        },
        getColorFromVendedorId(id) {
            let ven = this.markers.find((m) => m.vendedorId == id);

            if (ven != undefined && ven.icon.fillColor != undefined) {
                return ven.icon.fillColor;
            }
            
            return this.colors[(4 + (id * 2)) % this.colors.length];
        },
        getLabel(option) {
            return this.$t(option.toLowerCase()).toUpperCase();
        },
        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach((e) => {
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        },
        validaEndereco(infoWindow) {
            const enderecoValido = () => {
                return (
                    (infoWindow.item.endereco == '' || infoWindow.item.endereco == 'null') &&
                    (infoWindow.item.numero == '' || infoWindow.item.numero == 'null') &&
                    (infoWindow.item.bairro == '' || infoWindow.item.bairro == 'null')
                );
            };
            return enderecoValido();
        },
    },
    computed: {
        google: gmapApi,
        sellers: function () {
            let s = this.vendedores.filter((v) => {
                return v.clients.length > 0;
            });

            if (this.isOrderedBy == 'nome') {
                s.sort(this.compareNome);
            } else if (this.isOrderedBy == 'qtd') {
                s.sort(this.compareQTD);
            }

            return s;
        },
        total: function () {
            let total = 0;

            this.vendedores.forEach((v) => {
                total += v.clients.length;
            });

            return {
                clientes: total,
                vendedores: this.vendedores.length,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
// Botão de retrair
$btn-width: 32px;
$btn-height: 40px;

@mixin border() {
    border: 1px solid $table-border;
    border-radius: 3px;
}

#main {
    padding: 0px 20px;
    height: 100%;
}

.seller-btn {
    display: inline-block;
    outline: 0;
    border: 1px solid $primary-color;
    cursor: pointer;
    border-radius: 0.25rem;
    background-color: white;
    color: $primary-color;
    padding: 0 3.5px;
    &:hover {
        background-color: $primary-color-hover;
        border-color: $primary-color-hover;
        color: #fff;
    }
}
h1.title {
    margin-bottom: 0 !important;
}

.disabled {
    opacity: 0.4;
    pointer-events: none;
}

.control-right {
    .lista-vendedores {
        width: 100%;
        height: calc(100% - 125px);
        background-color: rgba($bg-color, 0.9);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding: 0.75rem;

        .table-controls {
            display: flex;
            border: 1px solid $table-border;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom: 0;
            height: 1.5rem;
            align-items: center;
            font-weight: 600;

            .vendedor-header {
                display: flex;
                align-items: center;
                width: 70%;
                height: 100%;
                padding-left: 20px;
                justify-content: space-between;
                cursor: pointer;

                &:hover {
                    background: $table-border;
                }
            }

            .cliente-header {
                display: flex;
                align-items: center;
                width: 30%;
                height: 100%;
                justify-content: flex-end;
                padding-right: 8px;
                cursor: pointer;

                &:hover {
                    background: $table-border;
                }

                .svg-icons {
                    right: 12px;
                }

                &.ordered {
                    justify-content: space-between;
                }
            }
        }

        .lista-wrapper {
            height: calc(100% - 4rem);
            margin-bottom: -0.75rem;

            .lista-container {
                border-left: 1px solid $table-border;
                border-right: 1px solid $table-border;
                margin: 0.75rem;
                overflow-y: scroll;

                & > .columns.is-multiline {
                    margin: 0;
                }

                .lista-item {
                    padding: 0.25rem;
                    cursor: pointer;

                    .vendedor {
                        display: flex;
                        align-items: center;
                        justify-items: flex-start;
                        width: 70%;

                        .text {
                            padding-left: 5px;
                        }
                    }

                    .estatistica {
                        display: flex;
                        align-items: center;
                        width: 30%;
                        justify-content: flex-end;
                    }

                    .inativo {
                        text-decoration: line-through;
                        color: #999;
                    }
                }
            }
        }

        .table-count {
            display: flex;
            border: 1px solid $table-border;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            height: 1.5rem;
            align-items: center;
            justify-content: space-around;
            font-weight: 600;
        }
    }

    .filtros-main {
        padding: 10px;

        label {
            color: #666666;
            font-size: 11px;
            margin-bottom: 6px;

            &:not(:first-child) {
                margin-top: 6px;
            }
        }
    }
}

.page {
    position: relative;
}

h1.title {
    margin-right: 0;
    margin-bottom: 1rem;
}

.btn-row {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
}

.primary-btn {
    color: $sovis-white;
    font-size: 10px;
    height: 30px;
    text-align: center;
    margin-left: 0px;
    border: none;
    border-radius: 6px;
    @include gradient-button();

    &.marcar {
        width: calc(50% - 5px);
    }
}

.normal-btn {
    color: $darker-gray-color;
    font-size: 10px;
    height: 30px;
    text-align: center;
    margin-left: 0px;
    margin-bottom: 10px;
    border: none;
    border-radius: 6px;
    @include exclude-button();
}

.alnright {
    text-align: right;
}

.mapa-wrapper {
    .vue-map-container {
        width: 100%;
        height: calc(100vh - 152px);
    }
}

.item-detail {
    float: right;
}

@mixin btn() {
    width: 100%;
    padding: 5px;
    margin: 5px 0px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border: none;
    border-radius: 3px;
    outline: none;
}

.btn-expand {
    color: $darker-gray-color;
    @include btn();

    &:active {
        background-color: $darker-bg-color;
    }

    &:hover,
    &:focus {
        background-color: $table-border;
    }
}

.btn-cadastro {
    background-color: $primary-color;
    color: $sovis-white;
    @include btn();

    &:active {
        background-color: $primary-color-click;
    }

    &:hover,
    &:focus {
        background-color: $primary-color-hover;
    }
}

.svg-icons {
    width: 2rem !important;
    height: 2rem;

    fill: orange;
}

.b-warning-client {
    background: transparent;
    border: none;
}

.modal-warning-list-client {
    background: #fff;
    width: 100%;
    height: auto;
    padding: 2rem;
    border: 4px solid var(--primary-color);
}

.modal-client-item-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.control-tabs {
    margin-top: 1rem;
}
</style>
